import type { PermissionsScope } from '../../core';
import type { CommunityId } from 'domain/CommunityId';

/**
 * Exactly one target, or none when there is no community to be scoped to (R1, KTD7).
 *
 * Takes the ids rather than a scope object, so the caller can hold them as primitives and keep the
 * hook's memo stable.
 *
 * **Shared by the hook and the state-form selector, and that is the point.** Two copies could answer
 * differently about which scope was being asked - the hook subscribing one cache key while the thunk
 * awaited another. One function makes that drift unrepresentable. The rest of the service hook is
 * retry backoff, failure counting and outage reporting, which a Redux listener has no use for.
 */
export const resolveServiceScope = (
  communityId: CommunityId | undefined,
  organisationId: number | undefined
): PermissionsScope | undefined => {
  if (organisationId !== undefined) return { organisationId };

  return communityId !== undefined ? { communityId } : undefined;
};

/** One frozen empty set rather than a new one per call, shared for the same reason. */
export const NO_SERVICE_GRANTS: ReadonlySet<never> = new Set<never>();
